import {
  GameAssetsContext,
  GameAssetsContextProvider,
} from '@/shared/GameComponents/GameAssetsContext/GameAssetsContext';
import GameSpinner from '@/shared/GameComponents/UI/GameSpinner/GameSpinner';
import {
  font,
  getAbsoluteAudioPath,
  getAbsoluteImagePath,
} from '../sortImages.utils';
import Head from 'next/head';

export default function SortImagesAssetsLoader({ activity, children }) {
  const folder = activity?.data?.folder;
  const questions = activity?.data?.questions;
  return (
    <>
      <Head>
        <link href={font.url} rel="stylesheet"></link>
      </Head>
      <GameAssetsContextProvider
        key={activity.id}
        gameAssetsFolder={folder}
        gameData={questions}
        prepareAssets={async () => {
          const soundsData = {};
          const imagesData = {};
          for (const question of questions) {
            soundsData[question.id] = {
              id: question.id,
              audio: getAbsoluteAudioPath(folder, question.audio),
            };
            imagesData[question.id] = {
              id: question.id,
              src: getAbsoluteImagePath(folder, question.image),
            };
          }
          return { soundsData, imagesData };
        }}
      >
        <GameAssetsContext.Consumer>
          {(gameAssets) =>
            gameAssets.state.isReady ? children : <GameSpinner />
          }
        </GameAssetsContext.Consumer>
      </GameAssetsContextProvider>
    </>
  );
}
